"use client";

import dynamic from "next/dynamic";

const HLSVideo = dynamic(() => import("../HLSPlayer/index.js"), {
  ssr: true,
});

export default HLSVideo;